import React, { useState, useEffect } from 'react';
import importService from '../../services/importService';

const ImportProgress = ({ importId, onComplete }) => {
  const [progress, setProgress] = useState(0);
  const [status, setStatus] = useState('processing');
  const [error, setError] = useState(null);

  useEffect(() => {
    let intervalId;

    const checkProgress = async () => {
      try {
        const result = await importService.getImportStatus(importId);
        
        if (result.success) {
          setProgress(result.data.progress);
          setStatus(result.data.status);
          
          if (result.data.status === 'completed' || result.data.status === 'failed') {
            clearInterval(intervalId);
            onComplete(result.data);
          }
        }
      } catch (err) {
        console.error('Erreur lors de la vérification du progrès:', err);
        setError(err.message);
        clearInterval(intervalId);
      }
    };

    // Vérifier immédiatement
    checkProgress();
    
    // Puis vérifier toutes les 1000ms
    intervalId = setInterval(checkProgress, 1000);

    return () => {
      if (intervalId) {
        clearInterval(intervalId);
      }
    };
  }, [importId, onComplete]);

  return (
    <div className="w-full max-w-md mx-auto">
      <div className="mb-4">
        <div className="flex justify-between mb-1">
          <span className="text-sm font-medium text-gray-700">
            Importation en cours...
          </span>
          <span className="text-sm text-gray-500">{progress}%</span>
        </div>
        <div className="w-full bg-gray-200 rounded-full h-2.5">
          <div 
            className="bg-blue-600 h-2.5 rounded-full transition-all duration-300 ease-out" 
            style={{ width: `${progress}%` }}
          ></div>
        </div>
      </div>
      
      {status === 'processing' && (
        <p className="text-sm text-gray-600 text-center">
          Traitement des contrats...
        </p>
      )}
      
      {error && (
        <p className="text-sm text-red-600 text-center mt-2">
          Erreur : {error}
        </p>
      )}
    </div>
  );
};

export default ImportProgress;